module.exports = __webpack_public_path__ + "static/media/7qRFj8T1A14TVps8rk83DA6znKmIUiPDvrqOpTod.c9b518f4.webp";